import moment from 'moment/moment';

class CountdownTimer
{
    constructor() {
        this.interval = null;
        this.callback = null;
        this.wrapper = '.container-match-countdown';
    }

    fire() {
        clearInterval(this.interval);
        if (this.callback) {
            this.callback();
        }
    }

    onFinish(callback) {
        this.callback = callback;
    }

    countdown() {
        if (this.duration.asSeconds() < 1) {
            this.fire();
            return;
        }

        this.duration.subtract(1, 'seconds');
        this.render();
    }

    hide() {
        $(this.wrapper).html('');
    }

    render() {
        const $container = $(this.selector);

        let hours = Math.floor(this.duration.asHours());
        let minutes = this.duration.minutes();
        let seconds = this.duration.seconds();

        if (hours > 999) {
            hours = 999;
        }

        hours = hours < 10 ? `0${hours}` : hours;
        minutes = minutes < 10 ? `0${minutes}` : minutes;
        seconds = seconds < 10 ? `0${seconds}` : seconds;

        $container.find('.hh strong').text(hours);
        $container.find('.mm strong').text(minutes);
        $container.find('.ss strong').text(seconds);
    }

    update(event) {
        this.event = event;
        this.duration = moment.duration(this.event.diff(moment()));

        this.render();
    }

    run() {
        this.interval = setInterval(() => {
            this.countdown();
        }, 1000);
    }

    init(selector) {
        this.selector = selector;
    }
}

export default CountdownTimer;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/match-bar/countdown.js